var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dataReady)?_c('div',{staticClass:"print-block"},[_c('div',{staticStyle:{"font-size":"12pt","font-weight":"600","margin-bottom":"0.5rem"}},[_vm._v("Efiling Status: ")]),_c('b-table',{attrs:{"items":_vm.rflmInfo,"fields":_vm.fields,"bordered":"","small":"","head-variant":"light","responsive":"sm"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }